import { ReactComponent as PlaylistIcon } from 'resources/images/playlist.svg';
import { Icon } from '@chakra-ui/react';
import { routes } from 'app/routing/routesConfig';
import { LinkWithActiveState } from '../LinkWithActiveState';

export const PlaylistButton = () => (
  <LinkWithActiveState to={routes.playerPlaylist.path}>
    <Icon
      as={PlaylistIcon}
      w={4}
      h={4}
      data-testid="toggle-extend-playlist-button"
    />
  </LinkWithActiveState>
);
